import { FC } from 'react';
import { GridFilterItem } from '../common/grid/GridFilterItem';
import {
  supplierListActions,
  SupplierListFilter,
} from '../../store/entities/supplierList';
import { GridFilterSupplierState } from '../common/grid/GridFilterSupplierState';

interface Props {
  query: SupplierListFilter;
}

export const SupplierFilter: FC<Props> = ({ query }) => {
  return (
    <>
      <GridFilterItem
        query={query}
        gridActions={supplierListActions}
        name="state"
        title="supplier.state"
        Component={GridFilterSupplierState}
      />
    </>
  );
};
